export enum CleanCleanerRole {
  CLEANER = 'CLEANER',
  CLEANER_LIMITED = 'CLEANER_LIMITED',
  MANAGER = 'MANAGER'
}
